import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

export const landingApi = {
  /**
   * Get discovery categories
   */
  getCategories: async () => {
    const response = await axiosClient.get(API_ENDPOINTS.MARKETS_DISCOVERY_CATEGORIES);
    return response.data;
  },

  /**
   * Get discovery tags
   */
  getTags: async () => {
    const response = await axiosClient.get(API_ENDPOINTS.MARKETS_DISCOVERY_TAGS);
    return response.data;
  },

  /**
   * Get tags by category slug
   */
  getTagsBySlug: async (slug: string) => {
    const response = await axiosClient.get(API_ENDPOINTS.MARKETS_TAGS_BY_SLUG(slug));
    return response.data;
  },
};
